import {TrueGrit} from "../TrueGrit";
import {TrueGritOutroView} from "./base/TrueGritOutroView";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {TimelineLite, TweenLite, TweenMax, TimelineMax, Linear, Back, Power1,Power2,Power3,Power4,Elastic, Bounce, gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

/**
 * Created by Jerker Nord on 2021-09-25.
 */

export class TrueGritMaxWinOutroView extends TrueGritOutroView {
    private _spine:PIXI.spine.Spine;
    private bitmapText:PIXI.BitmapText;
    private textLoop:gsap.core.Timeline | undefined;

    constructor() {
        super();
        this.name = "TrueGritMaxWinOutroView";
    }

    protected getOutroContent():PIXI.Container {
        const container = new PIXI.Container();

        this.bitmapText = new PIXI.BitmapText("20220x",{
            fontName:TrueGritGameAssets.BITMAP_FONT_WIN_NUMBERS,
            fontSize:190,
            tint:0xffffff
        });
        this.bitmapText.position.set(360,230);
        this.bitmapText.pivot.set(this.bitmapText.width * 0.5, this.bitmapText.height * 0.5);
        this.bitmapText.alpha = 0;

        const spineMask = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.BW_MASK)[0])
        spineMask.anchor.set(0.5, 0.5);
        spineMask.position.set(360, 360);
        this._spine = new PIXI.spine.Spine(TrueGrit.assetLoader.getSpineAsset(TrueGritGameAssets.WIN_CAP_SPINE));
        this._spine.position.set(360, 360);
        this._spine.mask = spineMask;
        this._spine.addChild(spineMask);

        const frame = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.BW_FRAME)[0]);
        frame.anchor.set(0.5, 0.5);
        frame.position.set(360, 360);
        container.addChild(this._spine, spineMask, frame, this.bitmapText,);
        return container;
    }

    public showMaxWinBlackout(duration:number):gsap.core.Timeline{
        const tl:gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => this.onResize());
        tl.add(() => NolimitApplication.addLayer(this.name, this));
        tl.add(gsap.to(this._background, {duration:duration, alpha:1}));
        return tl;
    }

    public startSpineLoop() {
        this._spine.autoUpdate = true;
        this._spine.state.setAnimation(0, "wincap_loop", true);
    }

    public stopSpineLoop() {
        this._spine.state.setEmptyAnimation(0, 0);
        this._spine.autoUpdate = false;
    }

    protected getCountUpYPos() {
        return 160;
    }

    startTextLoop() {
        this.stopTextLoop();
        this.bitmapText.alpha = 1;
        this.textLoop = gsap.timeline({repeat:-1});
        this.textLoop.add(gsap.to(this.bitmapText, {duration:3, alpha:0.2, ease:"none"}));
        this.textLoop.add(gsap.to(this.bitmapText, {duration:3, alpha:1, ease:"none"}));

    }

    stopTextLoop() {
        if (this.textLoop && this.textLoop.isActive()){
            this.textLoop.kill();
            delete this.textLoop;
        }
        this.bitmapText.alpha = 0;
    }
}